"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FALLBACK_TREE_PROJECT_ID = exports.activeEdenTreeProjects = exports.activeTreeProjects = void 0;
const calculate_tree_project_probability_1 = require("../utils/calculate-tree-project-probability");
// These are our main (internal) tree projects — please do not export them standalone.
// The numbers correspond with each project's Wordpress id.
const ACCION_ANDINA = 5290;
const ETHIOPIA_GEWOCHA = 6244;
const KENYA_DUNDORI = 5369;
const KENYA_KAKAMEGA = 6302;
const KENYA_MAU = 3503;
const MADAGASCAR_KANDRANY = 6299;
const TANZANIA_MPIMBWE = 8646;
const UGANDA_BUSOGA = 8953;
const UGANDA_MBALE = 3546;
const UGANDA_MOUNT_ELGON_ITF = 8645;
// Tree projects currently live in the system
exports.activeTreeProjects = (0, calculate_tree_project_probability_1.calculateTreeProjectProbability)([
    [MADAGASCAR_KANDRANY, 42.806],
    [KENYA_MAU, 40.918],
    [UGANDA_BUSOGA, 7.208],
    [ETHIOPIA_GEWOCHA, 3.826],
    [UGANDA_MBALE, 2.796],
    [KENYA_KAKAMEGA, 1.206],
    [ACCION_ANDINA, 0.629],
    [KENYA_DUNDORI, 0.454],
    [UGANDA_MOUNT_ELGON_ITF, 0.105],
    [TANZANIA_MPIMBWE, 0.054],
]);
// Eden-price matched tree projects currently live in the system
exports.activeEdenTreeProjects = (0, calculate_tree_project_probability_1.calculateTreeProjectProbability)([
    [MADAGASCAR_KANDRANY, 51.128],
    [KENYA_MAU, 48.872],
]);
// Used as a fallback in situations where we need a default tree project id (should be
// used as a last resort)
exports.FALLBACK_TREE_PROJECT_ID = MADAGASCAR_KANDRANY;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidHJlZS1wcm9qZWN0cy5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy90cmVlLXByb2plY3RzL3RyZWUtcHJvamVjdHMudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7O0FBQUEsb0dBQThGO0FBRTlGLHNGQUFzRjtBQUN0RiwyREFBMkQ7QUFFM0QsTUFBTSxhQUFhLEdBQUcsSUFBSSxDQUFDO0FBQzNCLE1BQU0sZ0JBQWdCLEdBQUcsSUFBSSxDQUFDO0FBQzlCLE1BQU0sYUFBYSxHQUFHLElBQUksQ0FBQztBQUMzQixNQUFNLGNBQWMsR0FBRyxJQUFJLENBQUM7QUFDNUIsTUFBTSxTQUFTLEdBQUcsSUFBSSxDQUFDO0FBQ3ZCLE1BQU0sbUJBQW1CLEdBQUcsSUFBSSxDQUFDO0FBQ2pDLE1BQU0sZ0JBQWdCLEdBQUcsSUFBSSxDQUFDO0FBQzlCLE1BQU0sYUFBYSxHQUFHLElBQUksQ0FBQztBQUMzQixNQUFNLFlBQVksR0FBRyxJQUFJLENBQUM7QUFDMUIsTUFBTSxzQkFBc0IsR0FBRyxJQUFJLENBQUM7QUFFcEMsNkNBQTZDO0FBQ2hDLFFBQUEsa0JBQWtCLEdBQUcsSUFBQSxvRUFBK0IsRUFBQztJQUNoRSxDQUFDLG1CQUFtQixFQUFFLE1BQU0sQ0FBQztJQUM3QixDQUFDLFNBQVMsRUFBRSxNQUFNLENBQUM7SUFDbkIsQ0FBQyxhQUFhLEVBQUUsS0FBSyxDQUFDO0lBQ3RCLENBQUMsZ0JBQWdCLEVBQUUsS0FBSyxDQUFDO0lBQ3pCLENBQUMsWUFBWSxFQUFFLEtBQUssQ0FBQztJQUNyQixDQUFDLGNBQWMsRUFBRSxLQUFLLENBQUM7SUFDdkIsQ0FBQyxhQUFhLEVBQUUsS0FBSyxDQUFDO0lBQ3RCLENBQUMsYUFBYSxFQUFFLEtBQUssQ0FBQztJQUN0QixDQUFDLHNCQUFzQixFQUFFLEtBQUssQ0FBQztJQUMvQixDQUFDLGdCQUFnQixFQUFFLEtBQUssQ0FBQztDQUMxQixDQUFDLENBQUM7QUFFSCxnRUFBZ0U7QUFDbkQsUUFBQSxzQkFBc0IsR0FBRyxJQUFBLG9FQUErQixFQUFDO0lBQ3BFLENBQUMsbUJBQW1CLEVBQUUsTUFBTSxDQUFDO0lBQzdCLENBQUMsU0FBUyxFQUFFLE1BQU0sQ0FBQztDQUNwQixDQUFDLENBQUM7QUFFSCxzRkFBc0Y7QUFDdEYseUJBQXlCO0FBQ1osUUFBQSx3QkFBd0IsR0FBRyxtQkFBbUIsQ0FBQyJ9